import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/overlay";
import { queryClient } from "@/lib/queries";
import { useTheme } from "@/lib/theme";
import { clearWebOfflineCopies } from "@/desktop/edition";
import { App } from "./App";
import "./styles/global.css";

function ThemedToaster() {
  const theme = useTheme((s) => s.theme);
  return (
    <Toaster
      theme={theme}
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: "!rounded-md !border !border-border-strong !bg-bg !text-fg !font-sans !shadow-xl",
          description: "!text-fg-muted",
          actionButton: "!bg-fg !text-fg-inverse",
          cancelButton: "!bg-bg-muted !text-fg",
        },
      }}
    />
  );
}

// Web: projetos só na nuvem (apaga cópias que versões antigas guardavam no navegador).
clearWebOfflineCopies();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <App />
        <ThemedToaster />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);

// Abrir sem internet: o service worker guarda a interface e as leituras essenciais (ADR 0023).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
